export const workerTypes = {
  IMAGE: 'image',
  PDF: 'pdf',
  OFFICE: 'office',
  LEGACY_OFFICE: 'legacyOffice',
  WEBVIEWER_SERVER: 'webviewerServer',
  XOD: 'xod',
  CONTENT_EDIT: 'contentEdit',
  ALL: 'all',
};